import { render } from "./EmployeeTrackerLogs.vue?vue&type=template&id=6009f2cd&scoped=true"
import script from "./EmployeeTrackerLogs.vue?vue&type=script&lang=js"
export * from "./EmployeeTrackerLogs.vue?vue&type=script&lang=js"

import "./employee-tracker-log.scss?vue&type=style&index=0&id=6009f2cd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6009f2cd"]])

export default __exports__